<template>
    <div v-if="show">
        <van-tabbar v-model="select" active-color="red">
            <van-tabbar-item icon="wap-home-o" @click="$goto('select')">首页</van-tabbar-item>
            <van-tabbar-item v-if="$config.project !== 'hm'" icon="bag-o" @click="$goto('all_search')">选品
                <div slot="icon" style="font-size: 12px; border: 1px solid; padding: 2px; border-radius: 10px">搜</div>
            </van-tabbar-item>
<!--            <van-tabbar-item v-if="$common.canShowTaobao()" icon="bag-o" @click="$goto('select_tb')">淘宝-->
<!--                <div slot="icon" style="font-size: 12px; border: 1px solid; padding: 2px; border-radius: 10px">淘</div>-->
<!--            </van-tabbar-item>-->
            <van-tabbar-item icon="exchange" @click="$goto('changelink')">转链</van-tabbar-item>
            <van-tabbar-item icon="chart-trending-o" @click="$goto('data')">数据</van-tabbar-item>
            <van-tabbar-item icon="contact" @click="$goto('my')">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        name: "Wp_tabbar",
        props:{
            tabSelect:{type: Number, defaule: 0}
        },
        data() {
            return {
                select:0,
                show: true,
                // select_add_tb: 1,
                // select_add_pdd: 1,
                select_all_search: 1,
            }
        },

        created() {
            if(this.$config.project === 'hm'){
                this.select_all_search = 0;
            }
        },

        mounted(){
            this.resetSelect();
            if(this.$config.project !== 'hm'){
                this.hideTabbar();
            }
            if(this.$common.isClient_whole()){//|| this.$config.project === 'hm'
                this.show = false;
            }
        },
        watch:{
            tabSelect(newSelect){
                this.$log("newSelect = " + newSelect)
                this.select = newSelect;
            }
        },
        methods:{
            /**
             * 重新设置tabber绑定的select的值，以保障刷新等情况下页面与tabbar的选中状态一致
             */
            resetSelect() {
                // if(this.$common.canShowTaobao()){
                //     this.select_add_tb = 1;
                // }else{
                //     this.select_add_tb = 0;
                // }
                // if(this.$common.canShowPdd()){
                //     this.select_add_pdd = 1;
                // }else{
                //     this.select_add_pdd = 0;
                // }
                //
                // let add_temp = this.select_add_tb + this.select_add_pdd;
                let add_temp = this.select_all_search;

                let changelink_select = 1 + add_temp;
                let events_select = 2 + add_temp;
                let data_select = 2 + add_temp;
                let my_select = 3 + add_temp;
                let paydata_select = 3 + add_temp;
                if(this.$route.path.indexOf('select') !== -1 && this.select !== 0){
                    this.select = 0;
                }
                if(this.$route.path.indexOf('all_search') !== -1 && this.select !== (0  + this.select_all_search)){
                    this.select = 0 + this.select_all_search;
                }
                // if(this.$route.path.indexOf('select_pdd') !== -1 && this.select !== (0  + this.select_add_pdd)){
                //     this.select = 0 + this.select_add_pdd;
                // }
                // if(this.$route.path.indexOf('select_tb') !== -1 && this.select !== (0  + add_temp)){
                //     this.select = 0 + add_temp;
                // }
                if(this.$route.path.indexOf('changelink') !== -1 && this.select !== changelink_select){
                    this.select = changelink_select;
                }
                if(this.$route.path.indexOf('events') !== -1 && this.select !== events_select){
                    this.select = events_select;
                }
                if (this.$route.path.indexOf('data') !== -1 && this.select !== data_select) {
                    this.select = data_select;
                }
                if (this.$route.path.indexOf('my') !== -1 && this.select !== my_select) {
                    this.select = my_select;
                }
                if (this.$route.path.indexOf('paydata') !== -1 && this.select !== paydata_select) {
                    this.select = paydata_select;
                }
            },

            /**
             * 隐藏底部tab选项卡
             */
            hideTabbar(){
                //如果是邀请注册页面
                if(this.$route.path.indexOf('wx_public_regist') !== -1){
                    this.show = false;
                }

                // if(this.$common.hideTabbar()){
                if(this.$config.project === 'mini'){
                    this.show = false;
                }else{
                    this.show = true;
                    this.$wx.miniProgram.getEnv(res => {
                        if (res.miniprogram) {
                            this.show = false;
                        }else{
                            this.show = true;
                        }
                    });
                }

                if(this.$route.path.indexOf(("/article/")) !== -1){
                    this.show = false;
                }

                if(this.$route.path.indexOf('privacy') !== -1){
                    this.show = false;
                }
                if(this.$route.path.indexOf('business') !== -1){
                    this.show = false;
                }
                if(this.$route.path.indexOf('support') !== -1){
                    this.show = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
